import React, { useState } from 'react';
import { LayoutDashboardIcon, BarChart3Icon, DollarSignIcon, TruckIcon, ClipboardCheckIcon, BadgeIcon, UsersIcon, CalendarIcon, ArrowUpIcon, ArrowDownIcon, TrendingUpIcon, ShieldIcon, GlobeIcon, PieChartIcon, LineChartIcon, MapIcon, BellIcon, CheckCircleIcon, XCircleIcon, AlertTriangleIcon, MoreHorizontalIcon } from 'lucide-react';
import { DashboardOverview } from '../components/dashboard/alternative/DashboardOverview';
import { OrdersOverview } from '../components/dashboard/alternative/OrdersOverview';
import { QuotesOverview } from '../components/dashboard/alternative/QuotesOverview';
import { ClaimsOverview } from '../components/dashboard/alternative/ClaimsOverview';
import { SubscriptionOverview } from '../components/dashboard/alternative/SubscriptionOverview';
import { LanguageSelector } from '../components/LanguageSelector';
export function DashboardPageAlternative() {
  const [activeSection, setActiveSection] = useState('overview');
  return <div className="min-h-screen bg-gradient-to-br from-slate-900 to-blue-900" data-id="element-8001">
      {/* Dashboard header with navigation */}
      <div className="relative z-10 flex flex-col border-b border-white/10" data-id="element-8002">
        <div className="flex items-center justify-between p-6" data-id="element-8003">
          <div className="flex items-center" data-id="element-8004">
            <div className="p-2 mr-3 bg-blue-600 rounded-lg" data-id="element-8005">
              <LayoutDashboardIcon size={20} className="text-white" data-id="element-8006" />
            </div>
            <h1 className="text-2xl font-bold text-white" data-id="element-8007">Dashboard</h1>
          </div>
          <div className="flex items-center space-x-4" data-id="element-8008">
            <LanguageSelector data-id="element-8009" />
            <div className="relative" data-id="element-8010">
              <BellIcon size={20} className="text-blue-300 hover:text-white cursor-pointer transition-colors" data-id="element-8011" />
              <span className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 rounded-full text-xs flex items-center justify-center text-white" data-id="element-8012">
                3
              </span>
            </div>
            <div className="bg-blue-800/50 rounded-full w-8 h-8 flex items-center justify-center" data-id="element-8013">
              <span className="text-white font-medium" data-id="element-8014">JD</span>
            </div>
          </div>
        </div>
        {/* Horizontal navigation */}
        <div className="flex px-6 pb-2 overflow-x-auto" data-id="element-8015">
          <NavButton icon={<LayoutDashboardIcon size={18} data-id="element-8017" />} label="Overview" active={activeSection === 'overview'} onClick={() => setActiveSection('overview')} data-id="element-8016" />
          <NavButton icon={<TruckIcon size={18} data-id="element-8019" />} label="Orders" active={activeSection === 'orders'} onClick={() => setActiveSection('orders')} data-id="element-8018" />
          <NavButton icon={<DollarSignIcon size={18} data-id="element-8021" />} label="Quotes" active={activeSection === 'quotes'} onClick={() => setActiveSection('quotes')} data-id="element-8020" />
          <NavButton icon={<ClipboardCheckIcon size={18} data-id="element-8023" />} label="Claims" active={activeSection === 'claims'} onClick={() => setActiveSection('claims')} data-id="element-8022" />
          <NavButton icon={<BadgeIcon size={18} data-id="element-8025" />} label="Subscription" active={activeSection === 'subscription'} onClick={() => setActiveSection('subscription')} data-id="element-8024" />
        </div>
      </div>
      {/* Main content */}
      <div className="flex-1 p-6 overflow-auto" data-id="element-8026">
        {activeSection === 'overview' && <DashboardOverview data-id="element-8027" />}
        {activeSection === 'orders' && <OrdersOverview data-id="element-8028" />}
        {activeSection === 'quotes' && <QuotesOverview data-id="element-8029" />}
        {activeSection === 'claims' && <ClaimsOverview data-id="element-8030" />}
        {activeSection === 'subscription' && <SubscriptionOverview data-id="element-8031" />}
      </div>
    </div>;
}
function NavButton({
  icon,
  label,
  active,
  onClick
}) {
  return <button onClick={onClick} className={`flex items-center px-4 py-2 mr-2 rounded-lg transition-colors ${active ? 'bg-blue-600 text-white' : 'text-blue-300 hover:bg-blue-800/50 hover:text-white'}`} data-id="element-8032">
      <span className="mr-2" data-id="element-8033">{icon}</span>
      <span data-id="element-8034">{label}</span>
    </button>;
}